import { render, staticRenderFns } from "./InfraTracker.vue?vue&type=template&id=36f6a190&"
import script from "./InfraTracker.vue?vue&type=script&lang=js&"
export * from "./InfraTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports